module.exports = __webpack_public_path__ + "static/media/Intellect.fe56c3f4.svg";